export default "__VITE_ASSET__BF6FbJ9q__"